<div class="rich-text-editor" [ngClass]="columnIndent ? 'row' : ''">
  <div [ngClass]="columnIndent ? 'col-xs-10 col-xs-offset-1' : ''">
    <ng-container *ngIf="!display; else templateDisplay">
      <div [class.error-border]="(wordcount >= maxCharacters) || showErrorBorder">
        <div class="tiptap-editor-wrap">

          <ng-container *ngIf="editor && !disabled">
            <div class="tiptap-toolbar">
              <!-- Undo / Redo -->
              <button type="button" class="toolbar-btn" title="Undo"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().undo().run()"
                [disabled]="!tiptap.can().undo()">
                <i class="fas fa-undo"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Redo"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().redo().run()"
                [disabled]="!tiptap.can().redo()">
                <i class="fas fa-redo"></i>
              </button>

              <span class="toolbar-divider"></span>

              <!-- Formatting -->
              <button type="button" class="toolbar-btn" title="Bold"
                [class.active]="tiptap.isActive('bold')"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().toggleBold().run()">
                <i class="fas fa-bold"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Italic"
                [class.active]="tiptap.isActive('italic')"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().toggleItalic().run()">
                <i class="fas fa-italic"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Underline"
                [class.active]="tiptap.isActive('underline')"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().toggleUnderline().run()">
                <i class="fas fa-underline"></i>
              </button>

              <span class="toolbar-divider"></span>

              <!-- Alignment -->
              <button type="button" class="toolbar-btn" title="Align left"
                [class.active]="tiptap.isActive({ textAlign: 'left' })"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().setTextAlign('left').run()">
                <i class="fas fa-align-left"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Align centre"
                [class.active]="tiptap.isActive({ textAlign: 'center' })"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().setTextAlign('center').run()">
                <i class="fas fa-align-center"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Align right"
                [class.active]="tiptap.isActive({ textAlign: 'right' })"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().setTextAlign('right').run()">
                <i class="fas fa-align-right"></i>
              </button>

              <span class="toolbar-divider"></span>

              <!-- Lists -->
              <button type="button" class="toolbar-btn" title="Bullet list"
                [class.active]="tiptap.isActive('bulletList')"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().toggleBulletList().run()">
                <i class="fas fa-list-ul"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Numbered list"
                [class.active]="tiptap.isActive('orderedList')"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().toggleOrderedList().run()">
                <i class="fas fa-list-ol"></i>
              </button>
              <button type="button" class="toolbar-btn" title="Checklist"
                [class.active]="tiptap.isActive('taskList')"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().toggleTaskList().run()">
                <i class="fas fa-tasks"></i>
              </button>

              <span class="toolbar-divider"></span>

              <!-- Table -->
              <button type="button" class="toolbar-btn" title="Insert table"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()"
                [disabled]="tiptap.isActive('table')">
                <i class="fas fa-table"></i>
              </button>

              <ng-container *ngIf="tiptap.isActive('table')">
                <button type="button" class="toolbar-btn" title="Add column before"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().addColumnBefore().run()">
                  <i class="fas fa-indent"></i>
                </button>
                <button type="button" class="toolbar-btn" title="Add column after"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().addColumnAfter().run()">
                  <i class="fas fa-outdent"></i>
                </button>
                <button type="button" class="toolbar-btn" title="Delete column"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().deleteColumn().run()">
                  <i class="fas fa-minus-square"></i>
                </button>
                <button type="button" class="toolbar-btn" title="Add row before"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().addRowBefore().run()">
                  <i class="fas fa-plus"></i>
                </button>
                <button type="button" class="toolbar-btn" title="Add row after"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().addRowAfter().run()">
                  <i class="fas fa-plus-circle"></i>
                </button>
                <button type="button" class="toolbar-btn" title="Delete row"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().deleteRow().run()">
                  <i class="fas fa-minus"></i>
                </button>
                <button type="button" class="toolbar-btn toolbar-btn--danger" title="Delete table"
                  (mousedown)="$event.preventDefault()"
                  (click)="tiptap.chain().focus().deleteTable().run()">
                  <i class="fas fa-trash"></i>
                </button>
              </ng-container>

              <!-- Horizontal rule -->
              <button type="button" class="toolbar-btn" title="Horizontal rule"
                (mousedown)="$event.preventDefault()"
                (click)="tiptap.chain().focus().setHorizontalRule().run()">
                <i class="fas fa-grip-lines"></i>
              </button>

              <span class="toolbar-divider"></span>

              <!-- Link to goal -->
              <button type="button" class="toolbar-btn" title="Link to a goal"
                (mousedown)="$event.preventDefault()"
                (click)="openRichLinkModal()">
                <i class="fal fa-bullseye fa-fw"></i>
              </button>

              <!-- AI actions (gated on company feature flags) -->
              <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.AI_SHORTCUTS) || globals.hasFeature(eCompanyFeatures.AI_PROMPTS)">
                <span class="toolbar-divider"></span>

                <!-- Custom prompt button -->
                <button type="button" class="toolbar-btn toolbar-btn--ai" title="Custom AI prompt"
                  *ngIf="globals.hasFeature(eCompanyFeatures.AI_PROMPTS)"
                  [disabled]="aiState === 'loading'"
                  (mousedown)="$event.preventDefault()"
                  (click)="runAi('custom')">
                  <span class="ai-badge">AI</span>
                </button>

                <!-- Shortcuts dropdown -->
                <div class="rewrite-menu-wrap" *ngIf="globals.hasFeature(eCompanyFeatures.AI_SHORTCUTS)">
                  <button type="button" class="toolbar-btn toolbar-btn--ai ai-shortcuts-btn" title="AI writing tools"
                    [disabled]="aiState === 'loading'"
                    (mousedown)="$event.preventDefault()"
                    (click)="showRewriteMenu = !showRewriteMenu">
                    <i class="fal fa-wand-magic-sparkles fa-fw"></i>
                    <i class="fas fa-chevron-down ai-chevron"></i>
                  </button>
                  <div class="rewrite-dropdown" *ngIf="showRewriteMenu">
                    <button type="button" class="rewrite-option" (mousedown)="$event.preventDefault()" (click)="runAi('improve')">Improve writing</button>
                    <button type="button" class="rewrite-option" (mousedown)="$event.preventDefault()" (click)="runAi('professional')">More professional</button>
                    <button type="button" class="rewrite-option" (mousedown)="$event.preventDefault()" (click)="runAi('conversational')">More conversational</button>
                    <button type="button" class="rewrite-option" (mousedown)="$event.preventDefault()" (click)="runAi('concise')">More concise</button>
                    <button type="button" class="rewrite-option" (mousedown)="$event.preventDefault()" (click)="runAi('constructive')">More constructive</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Custom prompt input panel -->
          <ng-container *ngIf="editor && showCustomPromptInput && aiState === 'idle'">
            <div class="ai-panel">
              <div class="ai-panel-header">
                <i class="fal fa-keyboard fa-fw"></i>
                <span>Custom prompt</span>
              </div>
              <textarea class="custom-prompt-input"
                [value]="customPromptText"
                (input)="customPromptText = $any($event.target).value"
                (keydown.enter)="$event.preventDefault(); submitCustomPrompt()"
                placeholder="E.g. Summarise this as bullet points"
                rows="2"
                autofocus></textarea>
              <div class="ai-panel-actions">
                <button type="button" class="ai-panel-btn ai-panel-btn--primary"
                  [disabled]="!customPromptText.trim()"
                  (mousedown)="$event.preventDefault()"
                  (click)="submitCustomPrompt()">
                  <i class="fal fa-paper-plane fa-fw"></i> Send
                </button>
                <button type="button" class="ai-panel-btn"
                  (mousedown)="$event.preventDefault()"
                  (click)="cancelCustomPrompt()">Cancel</button>
              </div>
            </div>
          </ng-container>

          <!-- AI preview panel -->
          <ng-container *ngIf="editor && aiState !== 'idle'">
            <div class="ai-panel">
              <div class="ai-panel-header">
                <i class="fal fa-sparkles fa-fw"></i>
                <span>AI suggestion</span>
                <span class="ai-panel-status" *ngIf="aiState === 'loading'">Generating…</span>
                <span class="ai-panel-status ai-panel-status--error" *ngIf="aiState === 'error'">Something went wrong</span>
              </div>
              <div class="ai-panel-preview" *ngIf="(aiState === 'done' || aiState === 'loading') && aiResponse" [innerHTML]="aiResponse"></div>
              <div class="ai-panel-actions">
                <ng-container *ngIf="aiState === 'done'">
                  <button type="button" class="ai-panel-btn ai-panel-btn--primary" (mousedown)="$event.preventDefault()" (click)="acceptAi()">
                    <i class="fal fa-check fa-fw"></i> Accept
                  </button>
                  <button type="button" class="ai-panel-btn" (mousedown)="$event.preventDefault()" (click)="rejectAi()">Discard</button>
                </ng-container>
                <button type="button" class="ai-panel-btn" *ngIf="aiState === 'loading'" (mousedown)="$event.preventDefault()" (click)="rejectAi()">Cancel</button>
                <button type="button" class="ai-panel-btn" *ngIf="aiState === 'error'" (mousedown)="$event.preventDefault()" (click)="dismissAiError()">Dismiss</button>
              </div>
            </div>
          </ng-container>

          <div #editorContainer
            class="tiptap-editor-content"
            [class.is-disabled]="disabled"
            [style.min-height.px]="height">
          </div>

        </div>
      </div>

      <div class="text-right noselect"
        [class.text-danger]="(wordcount >= maxCharacters) || warnWordcount || showErrorBorder">
        {{ wordcount }} / {{ maxCharacters }}
      </div>
    </ng-container>

    <ng-template #templateDisplay>
      <app-rich-display [text]="value"></app-rich-display>
    </ng-template>
  </div>
</div>

<ng-container *ngIf="richLinkModalReady">
  <app-modal #richLinkModal [width]="'80%'" [maxWidth]="'1200px'" [height]="'80vh'" [maxHeight]="'80vh'" [showCloseButton]="true">
    <app-rich-link-modal #richLinkPicker
      (goalsSelected)="onGoalsSelected($event)">
    </app-rich-link-modal>
  </app-modal>
</ng-container>
